import type React from 'react'

import { Cards } from './constants'
import css from './styles.module.css'

// What the report will hold once the crawl lands, shown in place of the page
// list while there is nothing to list.
export const PromoCards: React.FC = () => (
  <div className={css.promo_cards}>
    {Cards.map(({ description, icon: Icon, title }) => (
      <div className={css.card} key={title}>
        <div className={css.icon}>
          <Icon />
        </div>
        <div className={css.title}>{title}</div>
        <div className={css.description}>{description}</div>
      </div>
    ))}
  </div>
)
